import { InnoInput } from '@innomotics/innomotics-build-react-lib';
import React, { CSSProperties, FocusEvent, useCallback, useRef, useEffect } from 'react';

export interface InputProps {
    label: string | JSX.Element;
    name: string;
    value: string;
    dark?: boolean;
    disabled?: boolean;
    error?: boolean;
    placeholder?: string;
    readonly?: boolean;
    required?: boolean;
    style?: CSSProperties;
    onFocusText?: string;
    getMessage?: (value: string) => string;
    onBlur?: (event: FocusEvent<HTMLInputElement>) => void;
    onFocus?: (event: FocusEvent<HTMLInputElement>) => void;
    onChange?: (value: string, name: string) => void;
}

const TextInput = ({ dark, disabled, label, name, required, value, getMessage, onBlur, onChange }: InputProps) => {
    const message = getMessage ? getMessage(value) : '';
    const id = `text-input-${name}`;
    const inputRef = useRef<HTMLInputElement | null>(null);

    useEffect(() => {
        const inputElement = inputRef.current;
        
        if (inputElement && onBlur) {
            const handleBlur = (event: Event) => {
                const focusEvent = event as any as FocusEvent<HTMLInputElement>;
                onBlur(focusEvent);
            };

            inputElement.addEventListener('blur', handleBlur);

            return () => {
                inputElement.removeEventListener('blur', handleBlur);
            };
        }
    }, [onBlur]);

    const handleValueChange = useCallback((event: CustomEvent<string>) => {
        const newValue = event.detail;

        if (onChange) {
            onChange(newValue, name);
        }
    }, [name, onChange]);

    return (
        <InnoInput
            label={label}
            variant={dark ? 'dark' : 'light'}
            disabled={disabled}
            readOnly={disabled}
            required={required}
            name={name}
            onValueChanged={handleValueChange}
            error={message}>
            <input id={id} ref={inputRef} type='text' value={value} onChange={() => { }} />
        </InnoInput>
    );
};

export default TextInput;
